import React, { Component } from "react";

export default class ViewSwitcher extends Component {
  render() {
    const children = this.props.children;
    const { activeView } = this.props;
    return (
      <div>
        {React.Children.map(children, (child, i) => {
          if (child.props.name === activeView) {
            return child;
          }
          return;
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ViewSwitcher/index.js